import { render } from "./Cod6DetailPage.vue?vue&type=template&id=ca90a7f4&scoped=true"
import script from "./Cod6DetailPage.vue?vue&type=script&lang=js"
export * from "./Cod6DetailPage.vue?vue&type=script&lang=js"

import "./Cod6DetailPage.vue?vue&type=style&index=0&id=ca90a7f4&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca90a7f4"]])

export default __exports__